import {
	Button,
	Flex,
	SlidedownPortal,
	StandardModal,
	TextButton,
} from '@bamboohr/fabric';
import {
	hasDeclinedPasskeySetup,
	isKnownPasskeyUser,
	isPasskeySupported,
	registerPasskey,
} from '@bamboohr/utils/lib/authentication';
import { useState } from 'react';
import { render } from 'base/wrapped-render-v2';
import { PasskeyFacts } from '../login/login/components/passkey-facts';

export function showRecommendPasskeysModal() {
	if (
		isPasskeySupported() &&
		window.SESSION_USER.loginType === 'password' &&
		!window.SESSION_USER.hasPasskey &&
		!isKnownPasskeyUser() &&
		!hasDeclinedPasskeySetup()
	) {
		render({
			children: <RecommendPasskeysModal />,
			attachedElement: document.createElement('div'),
		});
	}
}

function RecommendPasskeysModal() {
	const recommendPasskeysModalBiId = 'recommend-passkeys-modal';
	const [isModalOpen, setIsModalOpen] = useState(true);
	const [isSuccessSlidedownOpen, setIsSuccessSlidedownOpen] = useState(false);

	const handleRemindMeLater = () => {
		setIsModalOpen(false);
	};

	const handleNoThanks = () => {
		window.localStorage.setItem('bhr_declined_passkey_setup', 'true');
		setIsModalOpen(false);
	};

	const handleAddPasskey = async () => {
		await registerPasskey();
		setIsSuccessSlidedownOpen(true);
		setIsModalOpen(false);
		// exceptions handled in registerPasskey
	};

	return (
		<>
			<SlidedownPortal
				description={`${$.__(
					'You can use passkeys the next time you log in.',
				)} ${$.__(
					'You can manage your passkeys from your user account settings.',
				)}`}
				message={$.__('Success! Passkey created.')}
				onDismiss={() => setIsSuccessSlidedownOpen(false)}
				show={isSuccessSlidedownOpen}
				type="success"
			/>
			<StandardModal isOpen={isModalOpen} onRequestClose={handleRemindMeLater}>
				<StandardModal.Body
					renderFooter={
						<StandardModal.Footer
							actions={[
								<TextButton
									data-bi-id={`${recommendPasskeysModalBiId}-no-thanks`}
									key="noThanks"
									onClick={handleNoThanks}
								>
									{$.__('No Thanks')}
								</TextButton>,
								<Button
									data-bi-id={`${recommendPasskeysModalBiId}-remind-me-later`}
									key="remindMeLater"
									onClick={handleRemindMeLater}
									variant="outlined"
								>
									{$.__('Remind Me Later')}
								</Button>,
								<Button
									data-bi-id={`${recommendPasskeysModalBiId}-add-passkey`}
									key="addPasskey"
									onClick={handleAddPasskey}
								>
									{$.__('Add a Passkey')}
								</Button>,
							]}
						/>
					}
					renderHeader={
						<StandardModal.Header
							biId={recommendPasskeysModalBiId}
							title={$.__('Goodbye passwords. Hello passkeys! ')}
						/>
					}
					size="medium"
				>
					<StandardModal.Constraint>
						<Flex gap={4}>
							<PasskeyFacts showLearnMore={true} />
							<img
								alt="key with lock"
								height="162"
								src="https://staticfe.bamboohr.com/assets/images/user-key.svg"
								width="165"
							/>
						</Flex>
					</StandardModal.Constraint>
				</StandardModal.Body>
			</StandardModal>
		</>
	);
}
